import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';

export const fetchUpcoming = () => ({
  type: actionsTypes.FETCH_UPCOMING,
  payload: API.fetch_upcoming_movies(),
});

export const fetchTopRated = () => ({
  type: actionsTypes.FETCH_TOP_RATED,
  payload: API.fetch_top_rated_movies(),
});

export const fetchPopular = () => ({
  type: actionsTypes.FETCH_POPULAR,
  payload: API.fetch_popular_movies(),
});

export const fetchNowPlaying = () => ({
  type: actionsTypes.FETCH_NOW_PLAYING,
  payload: API.fetch_now_playing_movies(),
});

export const fetchTrending = () => ({
  type: actionsTypes.FETCH_TRENDING,
  payload: API.fetch_trending_movies(),
});
